import {useContext} from "react";

import {PromptContext} from "../providers/PromptContextProvider";
import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const usePrompt = () => {
    const context = useContext(PromptContext);

    const showPrompt = (text: string, params: Omit<IPromptProps, "text" | "isPromptOpen"> = {}) => {
        const newPromptProps: IPromptProps & IPromptInternalProps = {
            ...params,
            text,
            isPromptOpen: true
        };
        newPromptProps.promptPromise = new Promise((resolve, reject) => {
            newPromptProps.promptPromiseResolve = resolve;
            newPromptProps.promptPromiseReject = reject;
        });

        context.setPromptParamsWithDefaults?.(newPromptProps);

        return newPromptProps.promptPromise;
    };

    const closePrompt = () => {
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    return {
        showPrompt,
        closePrompt,
        context: context as IPromptProps,
        _internalContext: context
    };
};
import {useContext} from "react";

import {PromptContext} from "../providers/PromptContextProvider";
import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const usePrompt = () => {
    const context = useContext(PromptContext);

    const showPrompt = (text: string, params: Omit<IPromptProps, "text" | "isPromptOpen"> = {}) => {
        const newPromptProps: IPromptProps & IPromptInternalProps = {
            ...params,
            text,
            isPromptOpen: true
        };
        newPromptProps.promptPromise = new Promise((resolve, reject) => {
            newPromptProps.promptPromiseResolve = resolve;
            newPromptProps.promptPromiseReject = reject;
        });

        context.setPromptParamsWithDefaults?.(newPromptProps);

        return newPromptProps.promptPromise;
    };

    const closePrompt = () => {
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    return {
        showPrompt,
        closePrompt,
        context: context as IPromptProps,
        _internalContext: context
    };
};
